import { LexDatePipe } from '../../../../../../../pipes';
import { Widget } from '../../../../../../../providers/bridge-api/dashboard.service';
import { Utils } from '../../../../../../../utils/utils';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiSummaryTranslocoParameters } from './widget-ai-insights-summary.service';

export default class VolumeOverTimeSummaryParameters implements AiSummaryTranslocoParameters {
  constructor(private lexDatePipe: LexDatePipe) {}

  assembleParameters(selectedPoints: any[], widget: Widget<WidgetChartOptions>) {
    const translationKey = `widgets.ai-insights.summary.${widget.payload.type}OverTime`;

    selectedPoints.sort((p1, p2) => p1.category - p2.category);

    return selectedPoints.map((p, idx) => ({
      translationKey: `${translationKey}.${idx === 0 ? 'first-point' : 'rest-of-points'}`,
      translationParams: {
        fieldValue: p.pointDisplay ?? p.pointId ?? p.category,
        date: this.lexDatePipe.transform(p.category, 'long'),
        count: Utils.round(p.y),
      },
    }));
  }
}
